import { Component, HostBinding, Inject } from '@angular/core';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { FeatureFlagsMap, MmuFeatureFlagsService } from '../../feature-flags';
import { MMU_APP_CONTEXT, MmuAppContext } from '../../mmu-app-context';


interface MmuFooterLink {
  id: string;
  url: string;
  basePath: string;
  labelI18nKey: string;
  context: string;
  feature?: string;
  notMigratedToUseFrontendContainer?: boolean;
}

@Component({
  selector: 'mmu-footer',
  templateUrl: './mmu-footer.component.html'
})
export class MmuFooterComponent {
  @HostBinding('class.mui-footer')
  readonly _muiBaseClass = true;

  /* Use the ngx-translate-extract-marker function here to make sure the translation keys are not accidentally pruned. */
  links: MmuFooterLink[] = [
    {
      id: 'data-privacy-link',
      url: '/legal/data-privacy',
      basePath: '/user',
      labelI18nKey: 'global.footer.dataPrivacy',
      context: MmuAppContext.CONTAINER
    },
    {
      id: 'terms-of-use-link',
      url: '/legal/terms-of-use',
      basePath: '/user',
      labelI18nKey: 'global.footer.termsOfUse',
      context: MmuAppContext.CONTAINER
    },
    {
      id: 'third-party-licences-link',
      url: '/legal/thirdPartyLicenses',
      basePath: '/pages',
      labelI18nKey: 'global.footer.thirdPartyLicences',
      context: MmuAppContext.PAGES,
      notMigratedToUseFrontendContainer: true
    },
    {
      id: 'imprint-link',
      url: '/legal/imprint',
      basePath: '/user',
      labelI18nKey: 'global.footer.imprint',
      context: MmuAppContext.CONTAINER
    },
    /**
     * @deprecated FFKleanMenu
     */
    {
      id: 'clean-plus-terms-of-use-link',
      url: '/legal/clean-plus-terms-of-use',
      basePath: '/user',
      labelI18nKey: 'global.footer.termsOfUseCleanPlus',
      context: MmuAppContext.CONTAINER,
      feature: FeatureFlagsMap.FFKleanMenu
    }
  ];

  constructor(
    @Inject(MMU_APP_CONTEXT) public appContext: MmuAppContext,
    private featureFlagsService: MmuFeatureFlagsService,
    private _userService: MmuUserService
  ) {
    this.filterLinks();
  }

  private filterLinks(): void {
    this.links = this.links.filter((linkItem: MmuFooterLink) => this.shouldDisplayLink(linkItem)).map((linkItem: MmuFooterLink) => {
      /** @deprecated: Remove when MmuAppContext.PAGES has been migrated to use frontend-container
       Related to: MPROTAL-34627
       */
      if (linkItem.notMigratedToUseFrontendContainer && linkItem.context == this.appContext) {
        linkItem.basePath = '';
      }
      return linkItem;
    });
  }

  private shouldDisplayLink(linkItem: MmuFooterLink): boolean {
    return linkItem.feature ? this.featureFlagsService.isFeatureEnabled(linkItem.feature) : true;
  }
}
